import React from 'react';
import { Col, Row as AntRow, Typography } from 'antd';
import { scaleRating } from '@guuru/rating-common';
import { Rating } from '@guuru/react-rating';
import styled from 'styled-components';

const { Title } = Typography;

const Row = styled(AntRow)`
  h1 {
    margin-bottom: 0;
  }

  .ant-rate-star {
    font-size: 18px;
  }
`;

interface NameProps {
  expert:{
    name?: string | null;
    rating?: number | null;
  }
}

const Name = function ({ expert }: NameProps) {
  const { name, rating } = expert;

  return (
    <Row justify="space-between" align="middle" gutter={[16, 8]}>
      <Col flex="auto">
        <Title>{name}</Title>
      </Col>
      <Col flex="none">
        <Rating rating={scaleRating(rating)} hoverable={false} />
      </Col>
    </Row>
  );
};

export default Name;
